import * as t from "io-ts";
import { CustomerOptions } from "./CustomerOptions";

export const JobOverride = t.intersection([
  t.type({
    action: t.union([
      t.literal("mark_job_as_sat_note_delayed"),
      t.literal("mark_job_as_pending"),
      t.literal("mark_job_as_referred"),
      t.literal("mark_job_as_action_customer"),
      t.literal("mark_job_as_accepted"),
      t.literal("mark_job_as_declined"),
      t.literal("mark_job_as_cancelled"),
    ]),
  }),
  t.partial({
    customer_options: CustomerOptions,
    xref: t.string,
  }),
]);

export interface JobOverride {
  action:
    | "mark_job_as_sat_note_delayed"
    | "mark_job_as_pending"
    | "mark_job_as_referred"
    | "mark_job_as_action_customer"
    | "mark_job_as_accepted"
    | "mark_job_as_declined"
    | "mark_job_as_cancelled";
  customer_options?: CustomerOptions;
  xref?: string;
}
